export const connectedTextsIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Connected Texts is where you can download all of the connected texts students are reading and listening to in the WordFlight System. WordFlight recommends all students read aloud with their teacher weekly.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a subcategory to see texts for a specific grade band.'
  },
  {
    element: '#resourcesTable tbody tr:first-child',
    intro: 'Select a row to open the PDF for that connected text.'
  }
];
